module.exports = __webpack_public_path__ + "static/media/Cooperativa Norte.640846a5.jpg";